import * as thunks from './thunks';
import * as selectors from './selectors';
import * as constants from './constants';
import { filterBarSlice } from './slice';
import * as types from './types';

const { actions } = filterBarSlice;

export {
  constants,
  thunks,
  actions,
  selectors,
  types,
};

export default filterBarSlice.reducer;
